export const messagesEn = {
  PRICING_ACCESS_DENIED: "You do not have the right for this pricing action.",
  server: {
    exception: {
      badcredentials: "Please use a valid username or password!",
      accessdenied: "Access is denied!",
      unknown: "Unknown error occurred. Please try again later!",
      UNKNOWN_USER: "User could not be found! Please login again!",
      authentication: {
        USERNAME_DOES_NOT_EXIST:"Username does not exist. Please try again!",
        PASSWORD_DO_NOT_MATCH:"Password is not valid. Please try again!",
        TOKEN_COULD_NOT_BE_CREATED:"Error while trying to login. Please try again later!",
        COULD_NOT_GET_CURRENT_REQUEST:"Your session has been terminated. Please login again!",
        COULD_NOT_GET_CURRENT_TOKEN:"Your session has been terminated. Please login again!",
        NOT_BEARER_AUTHORIZATION:"Your session has been terminated. Please login again!",
        TOKEN_COULD_NOT_BE_REFRESHED:"Your session has been terminated. Please login again!",
        PRINCIPAL_MISMATCH:"Your session has been terminated. Please login again!",
        GOOGLE_SIGN_IN_FAILED: "Google sign in failed. Please try again later!",
        USER_IS_DISABLED: "Your account is disabled. Please contact support!",
      },
      registration: {
        REGISTRATION_FAILED: "Registration failed. Please try again later!",
        PASSWORD_TOO_WEAK: "Password is too weak. Please use another password!",
        HOTEL_ALREADY_REGISTERED: "This hotel has already been registered in another account!",
        COMPANY_ALREADY_EXISTS: "Company has already been registered!",
        PASSWORDS_DO_NOT_MATCH: "Passwords do not match!",
        SOCIAL_ACCOUNT_ALREADY_EXISTS: "This email has already been registered with a social account!",
        USERNAME_ALREADY_EXISTS: "This email has already been registered!",
        EMAIL_IS_NOT_VALID: "The email is not valid!",
        COMPANY_HOTEL_ALREADY_EXISTS: "One of the hotels has been already registered!",
        PROFILE_ALREADY_EXISTS: "This user has already been registered!",
        MAX_NUMBER_OF_COMPETITORS_SURPASSED: "You have reached the maximum number of competitors you can add in a property!",
        WEBHOTELIER_ID_ALREADY_EXISTS: "One of the Webhotelier IDs is already assigned to a registered property!",
        NO_WEBHOTELIER_ID: "Webhotelier ID is required for each registered property!",
        PASSWORD_DOES_NOT_VALIDATE: "Password should be more than 8 characters!",
		PROFILE_VERIFICATION_NOT_EXISTS: "The profile verification request does not exist!",
		PENDING_PROFILE_VERIFICATION_NOT_EXISTS: "No pending profile verification request was found!",
		DEFINE_AT_LEAST_ONE_PROPERTY: "Define at least one property to continue!",
		DEFINE_AT_LEAST_ONE_COMPETITOR: "Define at least one competitor to continue!",
		DEFINE_HOTEL_IN_PROPERTY: "Select a hotel for every property!",
		DEFINE_EACH_HOTEL_ONCE: "Each hotel can only be added once!",
		COUNTRY_NOT_FOUND: "The selected country could not be found!",
		HOTEL_NOT_FOUND: "The selected hotel could not be found!",
		ENRICH_AND_RANKING_PROCESS_FAILED: "Hotel setup could not be completed. Please try again later!",
		UPDATE_MARKET_STATE_PROCESS_FAILED: "The initial market update failed. Please try again later!",
		CANNOT_ACTIVATE_WEBHOTELIER_PROVIDER: "WebHotelier could not be activated for this property!",
		COMPANY_HOTEL_COULD_NOT_BE_CREATED: "The property could not be created!",
		HOTELS_ENRICHMENT_FAILED: "Hotel information could not be loaded!",
		COMPANY_HOTELS_RANKING_FAILED: "Hotel ranking could not be completed!",
		COMPETITOR_HOTEL_NOT_FOUND: "A selected competitor hotel could not be found!",
		ILLEGAL_ACTION_ON_STATE: "This registration action is not allowed in the current state!",
		INVALID_API_RESPONSE: "WebHotelier returned an invalid response!",
		API_ACCESS_ERROR: "WebHotelier could not be reached!",
		FOUND_MORE_THAN_ONE_COMPANY_HOTEL: "More than one property uses this WebHotelier account!",
      },
      profile: {
		PROFILE_NOT_FOUND: "The profile could not be found!",
        PASSWORD_DOES_NOT_VALIDATE: "Password should be more than 8 characters!",
        PASSWORDS_DO_NOT_MATCH: "Passwords do not match!",
        USERNAME_ALREADY_EXISTS: "Email has been already registered!",
        EMAIL_IS_NOT_VALID: "Email is not valid!",
        WRONG_OLD_PASSWORD: "The current password is not valid!",
        RESET_PASSWORD_REQUEST_KEY_EXPIRED: "The reset password request has been expired. Please visit the 'Forgot Password' page again!",
        PROFILE_SETTINGS_NOT_FOUND: "Profile Settings could not be loaded!",
        PROFILE_ALREADY_EXISTS: "This user has already been registered!",
				INVALID_CODE: "This code is invalid!",
				PROFILE_NOT_IN_SAME_COMPANY: 'You are not allowed to disable this profile!',
				CANNOT_DISABLE_YOUR_PROFILE: "You are not allowed to disable your own profile!",
				COUNTRY_NOT_FOUND: "The selected country could not be found!",
				PROFILE_HAS_ALREADY_COMPANY: "This profile already belongs to a company!",
				COMPANY_NOT_FOUND: "The company could not be found!"
      },
      trip: {
        TRIP_HOTEL_ALREADY_EXISTS: "This hotel already exists. Please select another one!",
        TRIP_UPDATES_LIMIT_REACHED: "You have reached the maximum amount of updates for today!",
        TRIP_SHOULD_HAVE_AT_LEAST_ONE_HOTEL: "You need to have at least one hotel in your trip!"
      },
      companyHotel: {
        COMPANY_HOTEL_ALREADY_EXISTS: "This property is already defined!",
        COMPANY_HOTEL_NEED_AT_LEAST_ONE_COMPANY_HOTEL: "You need to have at least one property defined!",
        MAX_NUMBER_OF_COMPETITORS_SURPASSED: "You have reached the maximum number of competitors you can add in a property!",
		COMPANY_HOTEL_COMPETITOR_COULD_NOT_BE_ADDED: "There was an error saving this property!",
		COMPANY_HOTEL_COULD_NOT_BE_FOUND: "The property could not be found!",
		COMPANY_HOTEL_DEFINE_AT_LEAST_ONE_COMPETITOR: "Define at least one competitor for this property!",
		COMPANY_HOTEL_DEFINE_HOTEL_IN_PROPERTY: "Select the main hotel for this property!",
		HOTEL_COULD_NOT_BE_FOUND: "The hotel could not be found!",
		COMPANY_HOTEL_ROOM_COULD_NOT_BE_FOUND: "The selected property room could not be found!",
		COMPANY_COULD_NOT_BE_FOUND: "The company could not be found!",
		PROFILE_COULD_NOT_BE_FOUND: "The profile could not be found!",
		ALERT_HOTEL_COULD_NOT_BE_FOUND: "The hotel associated with this alert could not be found!",
		HOTEL_NOT_FOUND: "The hotel could not be found!",
		COMPANY_HOTEL_SETTINGS_NOT_FOUND: "Property settings could not be found!",
		NO_WEBHOTELIER_ID: "A WebHotelier ID is required!",
		COMPANY_HOTEL_COULD_NOT_BE_SAVED: "The property could not be saved!",
		CANNOT_START_PROVIDER_ACTIVATION: "Provider activation could not be started!",
		CANNOT_START_HOTEL_ROOM_ENRICHMENT: "Room enrichment could not be started. Please try again later.",
		INVALID_PARSING_SETTINGS_INPUT: "The provider settings are invalid!",
		COMPANY_HOTEL_COMPETITORS_GROUP_COULD_NOT_BE_FOUND: "The competitor group could not be found!",
		COMPANY_HOTEL_COMPETITORS_GROUP_NAME_IS_REQUIRED: "A competitor group name is required!",
		COMPANY_HOTEL_COMPETITORS_GROUP_COULD_NOT_HAVE_MORE_THAN: "The competitor group contains too many hotels!",
		MARKET_AREA_COULD_NOT_BE_FOUND: "The market area could not be found!",
		MARKET_AREA_NOT_IN_REGION: "This market is not in the region of your hotel!",
		AT_LEAST_ONE_HOTEL_NEEDED_FOR_COMPETITORS_GROUP: "Add at least one hotel to the competitor group!"
      },
      marketState: {
		API_IS_NOT_AVAILABLE: "The service is not available at this time. Please try again later!",
		SERVER_ERROR: "The market state could not be loaded. Please try again later!",
		REFRESH_WITH_PROOF_NOT_ENABLED: "Refresh with proof is not enabled for this property!",
		REFRESH_WITH_PROOF_NOT_SUPPORTED_FOR_FILTER: "Refresh with proof is available only for Booking.com, Web, Public rates, with OTA off."
      },
      companyProfileInvitation: {
		COMPANY_PROFILE_INVITATION_NOT_EXISTS: "The invitation could not be found!",
		COMPANY_PROFILE_INVITATION_IS_OF_WRONG_STATE: "Invitation email cannot be sent because it was accepted or disabled!",
		SEND_COMPANY_PROFILE_INVITATION_COOLDOWN_PERIOD_VIOLATION: "Invitation email cannot be resent yet. Please wait at least 10 minutes!",
        COMPANY_PROFILE_INVITATION_ACCESS_CONTROLS_NOT_DEFINED: "Access controls are not defined for this invitation!",
      },
      pricing_architecture: {
			PRICE_RECOMMENDATION_FEEDBACK_EMPTY: 'Choose a verdict or write a comment.',
			PRICE_RECOMMENDATION_FEEDBACK_INVALID_PRICE: 'Enter a valid rate of zero or more.',
        PRICING_ARCHITECTURE_HAS_ALREADY_BEEN_ASSIGNED_TO_A_STRATEGY: "This pricing architecture has already been assigned to a strategy!",
        PRICING_ROOM_ALREADY_EXISTS_IN_ARCHITECTURE: "This pricing room already exists in architecture!",
        HOTEL_ROOM_MAPPING_TYPE_ALREADY_EXISTS_IN_ARCHITECTURE: "This market group already exists in architecture!",
        LATEST_PRICE_RECOMMENDATION_INTEGRATION_DOES_NOT_EXIST: "Latest price recommendation integration does not exist!",
        LATEST_PRICE_RECOMMENDATION_ROOM_INTEGRATION_DOES_NOT_EXIST: "Latest price recommendation room integration does not exist!",
        DISCREPANCY_BETWEEN_LATEST_ROOM_PRICE_AND_RECORDED_PRICE: "Discrepancy between latest room price and recorded price!",
        APPLY_PRICE_EXCEEDS_VALIDATION_DIFF_PERCENTAGE: "Apply price exceeds validation difference percentage!",
        LATEST_PRICE_RECOMMENDATION_ROOM_INTEGRATION_FAILED: "Latest price recommendation room integration failed!",
		SUBMIT_PRICES_FAILED: "Failed to submit prices. Please try again later!",
		CANNOT_FETCH_LATEST_ROOM_PRICES: "The latest room prices could not be loaded!",
		CANNOT_TRIGGER_RECOMMENDATION_UPDATE: "The recommendation update could not be started!",
		COMPANY_HOTEL_DOES_NOT_EXIST: "The property could not be found!",
		INVALID_PRICING_STRATEGY_COMPETITORS_IMPORTANCE_COMPETITORS: "Select valid competitors for the strategy!",
		INVALID_PRICING_STRATEGY_COMPETITORS_IMPORTANCE_NAME: "Enter a valid competitor-importance name!",
		INVALID_PRICING_STRATEGY_RULE: "The pricing strategy rule is invalid!",
		NO_ROOM_RECOMMENDATIONS_CREATED: "No price recommendations were found for the selected period!",
		PRICE_ARCHITECURES_DO_NOT_EXIST: "No pricing architectures were found!",
		PRICE_RECOMMENDATION_DOES_NOT_EXIST: "The price recommendation could not be found!",
		PRICE_RECOMMENDATION_STATE_DOES_NOT_EXIST: "The price recommendation state could not be found!",
		PRICE_SUBMISSION_NOT_ALLOWED: "Price submission is not enabled for this property!",
		PRICING_ARCHITECTURE_COMPETITORS_IMPORTANCE_DOES_NOT_EXIST: "The pricing architecture competitor importance could not be found!",
		PRICING_ARCHITECTURE_DOES_NOT_EXIST: "The pricing architecture could not be found!",
		PRICING_AUTOMATION_LOG_DOES_NOT_EXIST: "The pricing automation log could not be found!",
		PRICING_ROOM_DOES_NOT_EXIST: "The pricing room could not be found!",
		PRICING_STRATEGY_COMPETITORS_IMPORTANCE_DOES_NOT_EXIST: "The strategy competitor importance could not be found!",
		PRICING_STRATEGY_DOES_NOT_EXIST: "The pricing strategy could not be found!",
		ROOMS_SYNCHRONIZATION_FAILED: "Pricing rooms could not be synchronized!",
		ROOM_LOG_NOT_FOUND: "The room submission log could not be found!"
      },
      hotel: {
        HOTEL_COULD_NOT_BE_FOUND: "Hotel could not be found!"
      },
      saved_market_state_filter: {
        NAME_IS_EMPTY: "Name is required!",
        NAME_IS_TOO_LONG: "Name must be less than 20 characters!",
        SAVED_FILTER_ALREADY_EXISTS: "There is a filter with this name already!",
		SAVED_FILTERS_LIMIT_REACHED: "You have reached the maximum amount of saved filters!"
		},
		companyHotelSettings: {
			CALENDAR_TABLE_PICKUP_WINDOWS_INVALID: 'Pick one or two Pickup Windows: 3, 7, 15, 30 days or Last change.',
			NO_OPERATION_DEFINED: "No settings operation was specified!",
			NIGHTS_LIMIT_EXCEEDED: "The configured nights limit was exceeded!",
			NO_CURRENCY_DEFINED: "Select a currency before saving!"
		},
		company: {
			COMPANY_SETTINGS_NOT_FOUND: "Company settings could not be found!"
		},
		companyProfile: {
			COMPANY_PROFILE_ACCESS_CONTROLS_NOT_DEFINED: "Profile access controls are not defined!"
		},
		bi: {
			PERIOD_INVALID: "Choose a stay period of at most 24 months, with the first month before the last one.",
			GROUP_NOT_FOUND: "One of the groups no longer exists. Reload the groups and try again.",
			GROUP_TITLE_INVALID: "Each group needs a name of 1 to 40 characters.",
			GROUP_TITLE_DUPLICATE: "Two groups have the same name. Give each group its own name.",
			SEGMENT_IN_TWO_GROUPS: "A PMS segment can be in one group only.",
			PROPERTY_GROUP_TITLE_INVALID: "A group name has 1 to 40 characters.",
			PROPERTY_GROUP_TITLE_DUPLICATE: "Another group has this name. Give this group another name.",
			PROPERTY_GROUP_EMPTY: "A group needs at least one property.",
			PROPERTY_GROUP_HOTEL_INVALID: "A property of this group is no longer in BI. Reload the page and try again.",
			PROPERTY_GROUP_NOT_FOUND: "This group no longer exists. Reload the page.",
			SCOPE_INVALID: "Choose one property or one group.",
			BI_COLUMNS_INVALID: "The columns were not saved.",
			CHANNEL_KEY_INVALID: "A channel of a group has no name. Reload the groups and try again.",
			CHANNEL_IN_TWO_GROUPS: "A booking channel can be in one group only.",
			PROPERTY_GROUP_SUBTOTAL_OVERLAP: "A property can be in one subtotal group only. Reload the groups and try again.",
			PICKUP_ALERT_INVALID: "The alert setting was not saved: pick a reference, a direction and a whole percent from 1 to 100."
		},
		alert: {
			ALERT_RULE_NO_PRICE_RATIO_THRESHOLD: "Enter a price-ratio threshold for this alert!",
			ALERT_RULE_WRONG_PRICE_RANGE: "Enter a valid price range for this alert!",
			ALERT_RULE_NO_RANKING_POSITION_THRESHOLD: "Enter a ranking-position threshold for this alert!",
			ALERT_RULE_NO_IDEAL_RANKING_POSITION: "Enter an ideal ranking position for this alert!",
			ALERT_NO_NAME: "Enter a name for this alert!",
			ALERT_TIMEFRAME_NUM_OF_DAYS: "Enter a valid number of days for the alert timeframe!",
			ALERT_TIMEFRAME_TO_DATE: "Enter a valid end date for the alert timeframe!",
			ALERT_TIMEFRAME_FROM_DATE: "Enter a valid start date for the alert timeframe!",
			ALERT_SCHEDULE_TIME: "Enter a valid alert schedule time!",
			PROFILE_NOT_FOUND: "The alert profile could not be found!",
			ALERT_COMPANY_HOTEL_NOT_FOUND: "The alert property could not be found!",
			ALERT_COMPANY_NOT_FOUND: "The alert company could not be found!",
			ALERT_NO_RULE_DEFINED: "Define at least one rule for this alert!",
			ALERT_NO_SCHEDULE_DEFINED: "Define a schedule for this alert!",
			ALERT_NO_TIMEFRAME_DEFINED: "Define a timeframe for this alert!",
			ALERT_NOT_FOUND: "The alert could not be found!",
			ALERT_EXECUTION_NOT_FOUND: "The alert execution could not be found!",
			ALERT_NOTIFICATION_MARKET_STATE_NOT_FOUND: "The market state for this alert notification could not be found!",
			ALERT_RULE_NOT_FOUND: "The alert rule could not be found!",
			ALERT_RULE_NO_COMPETITORS: "Select at least one competitor for this alert!",
			ALERT_RULE_WRONG_TRIGGER_PERCENTAGE: "Enter a valid trigger percentage for this alert!"
		},
		market_state_export: {
			MARKET_STATE_EXPORT_NOT_FOUND: "The market-state export could not be found!",
			MARKET_STATE_EXPORT_SAME_REQUEST_IN_PROGRESS: "The same export is already in progress!",
			MARKET_STATE_EXPORT_SAME_REQUEST_TOO_SOON: "Please wait before requesting the same export again!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_NOT_FOUND: "The export delivery schedule could not be found!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_INVALID: "The export delivery schedule is invalid!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_REPORTS_REQUIRED: "Select at least one report for the export schedule!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_RECIPIENTS_REQUIRED: "Add at least one recipient to the export schedule!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_RECIPIENT_INVALID: "An export recipient email is invalid!",
			MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_PERIOD_REQUIRED: "Select a period for the export schedule!"
		},
		parity_export: {
			PARITY_EXPORT_SAME_REQUEST_TOO_SOON: "Please wait before requesting the same parity export again!"
		},
		review: {
			REVIEW_NOT_FOUND: "The review could not be found!",
			COMPANY_HOTEL_NOT_FOUND: "The review property could not be found!",
			PROFILE_HAS_NOT_ANY_ACCESS: "You do not have access to this review!",
			HOTEL_DOES_NOT_BELONG_TO_COMPANY_HOTEL: "This hotel does not belong to the selected property!",
			REVIEWS_INSIGHTS_DELIVERY_SCHEDULE_NOT_FOUND: "The review insights delivery schedule could not be found!",
			REVIEWS_INSIGHTS_DELIVERY_SCHEDULE_TYPE_REQUIRED: "Select a review insights schedule type!",
			REVIEWS_INSIGHTS_DELIVERY_SCHEDULE_RECIPIENTS_REQUIRED: "Add at least one review insights recipient!",
			REVIEWS_INSIGHTS_DELIVERY_SCHEDULE_RECIPIENT_INVALID: "A review insights recipient email is invalid!",
			REVIEWS_INSIGHTS_DELIVERY_SCHEDULE_INVALID: "The review insights delivery schedule is invalid!"
		},
		api: {
			webhotelier: {
				INVALID_API_RESPONSE: "WebHotelier returned an invalid response!",
				API_ACCESS_ERROR: "WebHotelier could not be reached!",
				FOUND_MORE_THAN_ONE_COMPANY_HOTEL: "More than one property uses this WebHotelier account!"
			}
      }
    }

  },
  common: {
    form: {
      error: {
        required: "This field is required!",
        email: "This field should be a valid email!"
      }
    }
  },
  org: {
    springframework: {
      security: {
        authentication: {
          DisabledException: "Your account is not verified. Please check your email or resend"
        }
      }
    }
  }
}
